'use strict';

/**
 * Questionnaire base component that asks questions like chatbot
 * 
 * 
 */

import React from 'react';
import BotChatBubble from "./../BotChatBubble/BotChatBubble.jsx";
import CodingSystemTranslator from "./../../Documental/View/CodingSystemTranslator.js";
import i18n from "./../../Documental/Localization/i18n.js";


class BotQuestion extends React.Component {

  constructor(props) {
    super(props);

    this.codingTranslator = new CodingSystemTranslator();
    this.showHidetimer = null;
    
    let displayState = 'initial';
    if( typeof props.cardDisplayState ){
      displayState = props.cardDisplayState;
    }

    let canMoveOn = false;

    let customTextAnswerTmp = ''; // isAnyAnswerPresent
    let answerOptions = [];
    for( var i in this.props.queuedQuestion.question.questionJson.answerOption ){
      let option = this.props.queuedQuestion.question.questionJson.answerOption[ i ] ;

      let selected = false;

      if( window.qHolder.isAnswerPresent( { linkId: this.props.queuedQuestion.question.questionJson.linkId }, option.valueCoding.code ) ){
        selected = true;
        canMoveOn = true;
      }

      let translatedOption = option.valueCoding.display;

      if( 
        typeof option.valueCoding.code != 'undefined'
      ){
        // system => http://documental.ee/fhir/codesystem/questionnaire/item
        let t = this.codingTranslator.getTranslatedDisplayForCodeAndCurentLanguage( option.valueCoding.system, option.valueCoding.code );
        if( t ){
          translatedOption = t;
        }
      }

      let extracted = this.extractOptionValueCode( option.valueCoding.code );
      

      if( extracted.isPreDefinedOption ) {
        // extra = extracted.lastLetter;
      }


      answerOptions.push( {
        'questionLinkId' : this.props.queuedQuestion.question.questionJson.linkId,
        'answerCode' : option.valueCoding.code,
        'answerText' : translatedOption,
        'extractedCode' : extracted,
        // TODO: Kasutada tõlke süsteemi 
        'answerSelected' : selected
      } );
    }

    //if( 'SR.0.1' == this.props.queuedQuestion.question.questionJson.linkId ){
    //  canMoveOn = true;
    //}

    let manuallyEnteredAnswers = [];

    // extract manually entered values
    /*
      {
          "linkId": "SR.7.15.1",
          "definition": "http://documental.ee/fhir/profile/questionnaire/item/decimal1",
          "code": [{
                  "system": "http://documental.ee/fhir/codesystem/questionnaire/item",
                  "code": "SR.7.15.1",
                  "display": "Exact duration"
              }
          ],
          "text": "Exact duration",
          "type": "decimal"
      }, {
          "linkId": "SR.7.15.2",
          "definition": "http://documental.ee/fhir/profile/questionnaire/item/decimal1",
          "code": [{
                  "system": "http://documental.ee/fhir/codesystem/questionnaire/item",
                  "code": "SR.7.15.2",
                  "display": "Approximate duration"
              }
          ],
          "text": "Approximate duration",
          "type": "decimal"
      }
    */
    
    if ( typeof this.props.queuedQuestion.question.questionJson.definition != 'undefined' && this.props.queuedQuestion.question.questionJson.definition == 'http://documental.ee/fhir/profile/questionnaire/item/form1' ){

      for( var i in this.props.queuedQuestion.question.questionJson.item ){
        let item = this.props.queuedQuestion.question.questionJson.item[ i ];
        let trasnlatedTitle = item.text;

        if( 
          typeof item.code != 'undefined' && 
          typeof item.code[ 0 ] != 'undefined' && 
          typeof item.code[ 0 ].code != 'undefined'
        ){
          // system => http://documental.ee/fhir/codesystem/questionnaire/item
          let t = this.codingTranslator.getTranslatedDisplayForCodeAndCurentLanguage( item.code[ 0 ].system, item.code[ 0 ].code );
          if( t ){
            trasnlatedTitle = t;
          }
        }


        manuallyEnteredAnswers.push( {
          'linkId' : item.linkId,
          'label' : trasnlatedTitle,
          'type' : item.type,
          'originalJson' : item
        });
      }
    }
    
    let canMoveBackwards = false;
    if( typeof props.canMoveBackwards != 'undefined' ){
      canMoveBackwards = props.canMoveBackwards;
    }

    this.state = {
      cardDisplayState : displayState,
      answerOptions : answerOptions, /// READ in not in only construcror.. also on recieve props?
      customTextAnswer : customTextAnswerTmp,
      manuallyEnteredAnswers: manuallyEnteredAnswers,
      canMoveOn : canMoveOn,
      canMoveBackwards : canMoveBackwards
    };

    this.handleSelectAnswer = this.handleSelectAnswer.bind( this );
    this.handleCustomTextChange = this.handleCustomTextChange.bind( this );
    this.handleMoveBack = this.handleMoveBack.bind( this );
    this.handleMoveOn = this.handleMoveOn.bind( this );
    this.handleFinishRequest = this.handleFinishRequest.bind( this );
    this.handleDebugFinishRequest = this.handleDebugFinishRequest.bind( this );
    this.handleDebugClick = this.handleDebugClick.bind( this );
    
  }
  
  
  static getDerivedStateFromProps(nextProps, prevState) {
    
    if (nextProps.cardDisplayState !== prevState.cardDisplayState) {
      return {
        cardDisplayState: prevState.cardDisplayState,
      };
    } else {
      return null;
    }
  }
  
  
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.cardDisplayState !== this.props.cardDisplayState ) {
      this.setState({
        cardDisplayState: this.props.cardDisplayState,
      });

      this.renderAnimationsAfterDisplayStateChange();
    }
  }

  
  extractOptionValueCode( answerOptionCode ) {

    let predef = false;

    let lastLetter = answerOptionCode.slice(-1);

    if( 
      lastLetter == 'W' || 
      lastLetter == 'S'
    ){
      // A S D W E T  + other O? 
      predef = true; 
    }
    /*
    if( 
      lastLetter == 'A' || 
      lastLetter == 'S' || 
      lastLetter == 'D' || 
      lastLetter == 'W' || 
      lastLetter == 'E' || 
      lastLetter == 'T'
    ){
      // A S D W E T  + other O? 
      predef = true; 
    }
    */

    let extracted = {
      'answerCode' : answerOptionCode,
      'isPreDefinedOption' : predef,
      'lastLetter' : lastLetter
    }

    return extracted;
  }


  componentDidMount() {
    this.renderAnimationsAfterDisplayStateChange();
  }


  renderAnimationsAfterDisplayStateChange(){
		var that = this;
    
    if( this.showHidetimer != null ){
      clearTimeout( this.showHidetimer );
    }

    // Card gets intitially animated "in" after initial render (or also if re-shown in future)
		this.showHidetimer = setTimeout( function(){
      if( that.state.cardDisplayState == 'initial' ){
        that.setState({
          cardDisplayState : 'shown'
        });
        that.showHidetimer = null;
      }
		}, 400 );
  }

  handleCustomTextChange( event ){
    
    // let canMoveOn = false;
    let canMoveOn = true;
    if( event.target.value.length > 0 ){
      canMoveOn = true;
    }

    this.setState({
      customTextAnswer: event.target.value,
      canMoveOn : canMoveOn
    });
  }


  handleDebugClick(){
    console.log( window.qHolder.getDebugAnswersList() );
  }
  


  handleSelectAnswer( e, answerCode ){

    let canSelectMany = false;

    // this.props.queuedQuestion.question.questionJson 
    /*
      "definition": "http://documental.ee/fhir/profile/questionnaire/item/scale1",
      "type": "choice",
      "repeats": false,

      
      "definition": "http://documental.ee/fhir/profile/questionnaire/item/choice1",
      "repeats": false,
      "type": "choice",


      "definition": "http://documental.ee/fhir/profile/questionnaire/item/options1",
      "type": "choice",
      "repeats": true,

      this.props.queuedQuestion.question.questionJson.
    */

    if( 
      this.props.queuedQuestion.question.questionJson.repeats
    ){
      canSelectMany = true;
    }
    



    let updateOptions = this.state.answerOptions;
    
    let currentOptionIndex = -1;
    let atLeastOneSpecialAnswerSelected= false;
    let atLeastOneCustomSelected= false;

    for( var i in updateOptions ){
      if( updateOptions[ i ].answerCode == answerCode ){
        currentOptionIndex = i;
      }
      if( updateOptions[ i ].answerSelected && updateOptions[ i ].extractedCode.isPreDefinedOption ){
        atLeastOneSpecialAnswerSelected = true;
      }
      if( updateOptions[ i ].answerSelected && !updateOptions[ i ].extractedCode.isPreDefinedOption ){
        atLeastOneCustomSelected = true;
      }
    }

    // if current option is some special option (with letter) we disable all other choices
    if( updateOptions[ currentOptionIndex ].extractedCode.isPreDefinedOption ){
      canSelectMany = false;
    }

    let removeveSpecialAnswers = false;

    for( var i in updateOptions ){
      if( updateOptions[ i ].answerCode == answerCode ){
        if( updateOptions[ i ].answerSelected ){
          updateOptions[ i ].answerSelected = false;
        } else {
          updateOptions[ i ].answerSelected = true;

          if( !updateOptions[ i ].isPreDefinedOption && atLeastOneSpecialAnswerSelected ){
            removeveSpecialAnswers = true;
          }
        }
        
      } else {
        if( !canSelectMany ){
          updateOptions[ i ].answerSelected = false;
        }
      }
    }

    if( removeveSpecialAnswers ){
      for( var i in updateOptions ){
        if( updateOptions[ i ].answerSelected && updateOptions[ i ].extractedCode.isPreDefinedOption && updateOptions[ i ].answerCode != answerCode ){
          updateOptions[ i ].answerSelected = false;
        }
      }
    }

    let howManySelected = 0;
    for( var i in updateOptions ){
      if( updateOptions[ i ].answerSelected ){
        howManySelected++;
      }
    }

    let atLeastOneSelected = false;
    if( howManySelected > 0 ){
      atLeastOneSelected = true;
    }

    if( !canSelectMany && atLeastOneSelected ){
      var that = this;
      atLeastOneSelected = true;
      setTimeout( function(){
        //that.handleMoveOn( );
      }, 400 );
    }
    
    let forceMoveOn = false;
    let canMoveOn = atLeastOneSelected;
    
    if( "SR.0.1" == this.props.queuedQuestion.question.questionJson.linkId ){
      if( howManySelected > 0 ){
        canMoveOn = true;
      } else {
        canMoveOn = false;
      }
      if( howManySelected > 6 ){
        forceMoveOn = true;
      }
    }

    if( forceMoveOn ){
      this.handleMoveOn();
      return;
    }

    this.setState({
      answerOptions : updateOptions,
      canMoveOn : canMoveOn
    });
    
    // this.forceUpdate()
  }

  
  /**
   * 
   */
  handleMoveOn( e ){

    let questionLinkId = this.props.queuedQuestion.questionLinkId;
    let answersSelected = [];
    // take answers selected and post them back into questionnaire
    let updateOptions = this.state.answerOptions;
    for( var i in updateOptions ){
      if( updateOptions[ i ].answerSelected ){
        answersSelected.push( {
          "answerCode" : updateOptions[ i ].answerCode
        } );
      }
    }
    
    this.props.onQuestionAnswered( questionLinkId, answersSelected );

    return false;
  }

    
  /**
   * 
   */
  handleMoveBack( ){
    this.props.onMoveBack(  );
  }

    
  /**
   * 
   */
 handleFinishRequest( ){
    this.props.onFinishRequst();
  }

    
  /**
   * 
   */
 handleDebugFinishRequest( ){
    
    //if( process.env.REACT_APP_CONFIG_ENV === "development" ){
      if( window.location.href.indexOf( 'app.documental.ee' ) > -1 || window.location.href.indexOf( 'localhost' ) > -1 || window.dmDebug.skipQuestionnaire ){
        this.props.onFinishRequst();
      }
    //}

  }

  
  render() {

    let translatedQuestion = this.props.queuedQuestion.question.questionJson.text;

    if( 
      typeof this.props.queuedQuestion.question.questionJson.code != 'undefined' && 
      typeof this.props.queuedQuestion.question.questionJson.code[ 0 ] != 'undefined'
    ){
      let t = this.codingTranslator.getTranslatedDisplayForCodeAndCurentLanguage( "http://documental.ee/fhir/codesystem/questionnaire/item", this.props.queuedQuestion.question.questionJson.code[ 0 ].code );
      if( t ){
        translatedQuestion = t;
      }
    }

		let botText = [
			{
				"text" : translatedQuestion,
				"loader" : false
			}
		];
    
		let classNames  = 'card-animate';

		if( this.state.cardDisplayState == 'shown' ){
			classNames = classNames + ' card-show';
		} else if( this.state.cardDisplayState == 'closed' ){
			classNames = classNames + ' card-hide';
		}

    var that = this;

    let topicText = '';
    let topicColorClass = '';
    if( this.props.queuedQuestion.question.questionInSection != null ){
      // topic-color-green   topic-color-blue
      topicText = this.props.queuedQuestion.question.questionInSection.title
      topicColorClass = 'topic-color-green';
    }

    /**
     * code: Array(2)
      0: {system: "http://documental.ee/fhir/codesystem/questionnaire/item", code: "SR.1.3", display: "Have you ever had a period of time, without being …l or physical fights, or shouted at other people?"}
      1:
      code: "SR.1"
      display: "Mood"
      system: "http://documental.ee/fhir/codesystem/question/tag"
     * 
     */

    topicText = '';

    // 
    let actionClasses = 'app-fragment pull-bottom-fixed pull-bottom-gradient question-buttons';
    //if( this.state.canMoveOn ){
    //  actionClasses = 'mdl-card__actions actions-show'; // actions-hide
    //}

    //if( this.props.canFinish || this.state.canMoveOn || this.state.canMoveBackwards ){
    //  actionClasses = 'app-fragment pull-bottom-fixed pull-bottom-gradient question-buttons';
    //}

    if( this.state.canMoveOn && this.state.canMoveBackwards ){
      actionClasses = 'app-fragment pull-bottom-fixed pull-bottom-gradient question-buttons';
    } else if( !this.state.canMoveOn && this.state.canMoveBackwards ) {
      actionClasses = 'app-fragment pull-bottom-fixed pull-bottom-gradient question-buttons'; //  question-buttons-only-back
    } else if( this.state.canMoveOn && !this.state.canMoveBackwards ) {
      actionClasses = 'app-fragment pull-bottom-fixed pull-bottom-gradient question-buttons question-buttons-only-next';
    } else if( !this.state.canMoveOn && !this.state.canMoveBackwards ) {
      actionClasses = 'app-fragment pull-bottom-fixed pull-bottom-gradient question-buttons question-buttons-none';
    }

    let translatedBtnForward = i18n.t( 'Next' );
    let translatedBtnBack = i18n.t( 'Previous' );
    let translatedBtnFinish = i18n.t( 'Finish' );
    
    
    let showSeperator = false;
    let countCustom = 0;
    let countPredefined = 0;
    for( var j in this.state.answerOptions  ){
      if( this.state.answerOptions[j].extractedCode.isPreDefinedOption ){
        countPredefined++;
      } else {
        countCustom++;
      }
    }

    if( (countCustom || this.state.manuallyEnteredAnswers.length ) && countPredefined ){
      showSeperator = true;
    }

    var isCustomTextAnswer = false;
    if( this.props.queuedQuestion.question.questionJson.type == "text" ){
      isCustomTextAnswer = true;
    }

    //let parts = this.props.queuedQuestion.question.questionJson.definition.split( '/' );
    let dbg = this.props.queuedQuestion.question.questionJson.linkId;
    dbg = dbg + ' / ' + this.props.queuedQuestion.question.questionJson.type;
    dbg = dbg + ' / repeats: ' + this.props.queuedQuestion.question.questionJson.repeats;
    //dbg = dbg + ' / ' + parts[ 7 ];

    dbg = '';

    var filterchipsClasses = 'filter-chips scrollable app-fragment';
    if( window.qHolder.isFakeRefugeeQuestion( this.props.queuedQuestion.question.questionJson.linkId ) ){
      filterchipsClasses = "filter-chips scrollable app-fragment"; // filter-chips-blocked 
    }

    // classNames = '';
    /**
     * 
     * 
          <div className="app-fragment question">
            <div className="question-avatar mb-3"></div>
            <div className="question-text">
              Kas te kardate olukordi, nagu üksinda reisimine, avalikes kohtades viibimine, mida võib olla raske vältida ja kus rahutustunde või paanikahoo korral ei pruugi abi kättesaadav olla?
            </div>
          </div>

          <div className="app-fragment">
            <a href="#" className="btn-inline-answer">Vähemalt neli järjestikust päeva, aga vähem kui nädal</a>
            <a href="#" className="btn-inline-answer">Jah</a>
            <a href="#" className="btn-inline-answer">Vahel harva</a>
            <a href="#" className="btn-inline-answer">ei</a>
            <a href="#" className="btn-inline-answer">Vähemalt neli järjestikust päeva, aga vähem kui nädal</a>
            <a href="#" className="btn-inline-answer">Jah</a>
            <a href="#" className="btn-inline-answer">Ei</a>
            <a href="#" className="btn-inline-answer">Jätan vastamata</a>
            <a href="#" className="btn-inline-answer selected">Ei soovi vastata</a>
            <a href="#" className="btn-inline-answer">Olen kindel</a>
            <a href="#" className="btn-inline-answer">Veel üks pakkumine</a>
            <a href="#" className="btn-inline-answer">Viimane</a>
          </div>
          
     * 
     */

    return (
      <div className={classNames}  data-dbg={this.props.queuedQuestion.question.questionJson.linkId}>
          <div className="mdl-card__supporting-text mdl-card--border" title={dbg}>
            
             
            <div className="app-fragment question">
              <div className="question-avatar mb-3" onClick={(e) => this.handleDebugFinishRequest()} ></div>
              <div className="question-text">
                {botText.map( function( obj, index){
                  let key = index + new Date().getTime();
                  let loaderKey = 'loadekey-static';
                  let classes = '';
                  let text = '&nbsp;';
                  
                  if( typeof obj.text != 'undefined' ){
                    text = obj.text;
                  }

                  if( typeof obj.isBold != 'undefined' && obj.isBold ){
                    classes = ' is-bold';
                  }
                  if( typeof obj.loader != 'undefined' && obj.loader ){
                    return (
                      <div className="p" key={loaderKey}>
                        <div className="container-loading">
                          <div className="mdl-spinner mdl-js-spinner is-active"></div>
                        </div>
                      </div>
                    );
                  }
                  
                  return (
                    <p key={key} className={classes}  onClick={(e) => that.handleDebugClick()} >
                      {obj.text}
                    </p>
                  );
                })}
              </div>
            </div>

            {isCustomTextAnswer && (
              <div className="custom-text-answer">
                <textarea 
                  value={this.state.customTextAnswer}
                  className="custom-text-answer-textarea"
                  onChange={this.handleCustomTextChange}
                >
                </textarea>
              </div>
            )}
            
            <div className={filterchipsClasses}>
              {this.state.answerOptions.map(function( answerOption, index ){ 
                if( answerOption.extractedCode.isPreDefinedOption ){
                  return;
                }
                let aoKey = that.props.queuedQuestion.question.questionJson.linkId + '-' + index;
                let wrapClasses = "mdl-chip-wrapper-NOT btn-inline-answer";
                if( answerOption.answerSelected ){
                  wrapClasses = wrapClasses + " active selected";
                }
                return (<span key={aoKey} className={wrapClasses} onClick={(e) => that.handleSelectAnswer( e, answerOption.answerCode )} >
                  <span className="">
                    {answerOption.answerText}
                  </span>
                </span>);
              })}

              {/* print out special options at the */}
              <div className="mt-4 mb-4">
                {this.state.answerOptions.map(function( answerOption, index ){
                  if( !answerOption.extractedCode.isPreDefinedOption ){
                    return;
                  }
                  let aoKey = that.props.queuedQuestion.question.questionJson.linkId + '-' + index;
                  let wrapClasses = "mdl-chip-wrapper-NOT btn-inline-answer btn-predefined-option btn-without-border";
                  if( answerOption.answerSelected ){
                    wrapClasses = wrapClasses + " active selected";
                  }
                  return (<span key={aoKey} className={wrapClasses} onClick={(e) => that.handleSelectAnswer( e, answerOption.answerCode )} >
                    <span className="mdl-chip__text">{answerOption.answerText}</span>
                  </span>);
                })}
              </div>

              {this.state.manuallyEnteredAnswers.map(function( manualAnswer, index ){ 
                let aoKey = manualAnswer.linkId;
                
                return (<span key={aoKey} onClick={(e) => that.handleSelectAnswer( e, manualAnswer.linkId )} >
                  <span className="mdl-chip">
                    <span className="mdl-chip__text">{manualAnswer.label}</span> <br />
                    
                    <div className="mdl-textfield mdl-js-textfield">
                      <input className="mdl-textfield__input" type="text" />
                      <label className="mdl-textfield__label" >{manualAnswer.label}</label>
                      <span className="mdl-textfield__error"></span>
                    </div>

                  </span>
                </span>);
              })}
              
            </div>

          </div>
          
          
          <div className={actionClasses}>
            {/*
            Moved to main answers part
            <div className="mb-4">
              {this.state.answerOptions.map(function( answerOption, index ){
                if( !answerOption.extractedCode.isPreDefinedOption ){
                  return;
                }
                let aoKey = that.props.queuedQuestion.question.questionJson.linkId + '-' + index;
                let wrapClasses = "mdl-chip-wrapper-NOT btn-inline-answer btn-predefined-option btn-without-border";
                if( answerOption.answerSelected ){
                  wrapClasses = wrapClasses + " active selected";
                }
                return (<span key={aoKey} className={wrapClasses} onClick={(e) => that.handleSelectAnswer( e, answerOption.answerCode )} >
                  <span className="mdl-chip__text">{answerOption.answerText}</span>
                </span>);
              })}
            </div>
            */}
            <div className="inner">

              {this.state.canMoveBackwards && (
                <span className="btn-navigate-back mb-6"  onClick={(e) => this.handleMoveBack()} 
                  href="#" title={translatedBtnBack} >
                </span>
              )}
            

              {/*this.props.canFinish && (
                <span className="btn next mb-6" onClick={(e) => this.handleFinishRequest()}
                  href="#" >
                  {translatedBtnFinish}
                </span>

              <span className="btn-navigate-back mb-6"  onClick={(e) => this.handleMoveBack()} 
                href="#" title={translatedBtnBack} >
              </span>
              )*/}
              
              {/*this.props.canFinish && (
                <span className="btn next mb-6" onClick={(e) => this.handleFinishRequest()}
                  href="#" >
                  {translatedBtnFinish}
                </span>
              )*/}



              {this.state.canMoveOn && (
                <span className="btn dark next center mb-6" onClick={(e) => this.handleMoveOn( e )} 
                  href="#"
                  >
                  {translatedBtnForward}
                </span>
              )}
              {!this.state.canMoveOn && (
                <span className="btn dark next center disabled mb-6" 
                  href="#"
                  >
                  {translatedBtnForward}
                </span>
              )}
            
            </div>
          </div>


        <br />
        {/*this.props.showProgressBar && (
          <ProgressBar percentage={this.props.progress}></ProgressBar>
        )*/}
        <br />

      </div>
    );

  }

}

export default BotQuestion;
